<template>
    <section class="dashboardContainer">
        <b-overlay :show="loading" no-wrap opacity="1">
        </b-overlay>
        <Filters @filter-changed="loadDahsboardData" @filter-reset="resetFilters" :dataToExport="exportGraphs"
            :showExport="true" :isGraph="true" />
        <section class="statusHeader">
            <section class="statusCards" v-for="(status, stIdx) in this.statusCards" :key="stIdx"
                v-show="status.canShow">
                <h2>{{ status.count }}</h2>
                <div>
                    <img :src="require(`@/assets/rta/status/${status.icon}.svg`)" alt="Status Icon" />
                    <span>{{ status.label }}</span>
                </div>
            </section>
        </section>
        <button @click="toggleDetailedStatus" class="showDetailsBtn">
            <span>Ocultar Detalhes</span>
            <b-icon-chevron-expand />
        </button>
        <section class="graphContainer">
            <RTAGraphs type="pie" title="RTAs por Status" :labels="this.statusGraph.labels"
                :data="this.statusGraph.data" class="graph1" ref="statusGraphRef" />

            <RTAGraphs type="bar" title="RTAs por Responsável" :labels="respGraph.labels" :data="respGraph.data"
                :categories="respGraph.categories" class="graph2" ref="respGraphRef" />

            <RTAGraphs type="line" title="RTAs Abertas por Indicador" :labels="indGraph.labels" :data="indGraph.data"
                :categories="indGraph.categories" class="graph3" ref="indGraphRef" />

            <section class="graph4">
                <p>Últimas Atualizações</p>
                <ve-table rowKeyFieldName="rowKey" :fixed-header="true" :columns="lastUpdateCols"
                    :table-data="lastUpdateData" :rowStyleOption="rowStyleOption"
                    :column-width-resize-option="columnWidthResizeOption" border-y :cell-style-option="cellStyleOption"
                    max-height="11.5rem" />
                <button @click="gotToRtaList" style="word-break:break-word">
                    <span>Ver Relatório Completo</span>
                    <b-icon-box-arrow-up-right></b-icon-box-arrow-up-right>
                </button>
            </section>

            <RTAGraphs type="bar" title="Avaliação de RTAs e Plano de Ações" :labels="efficGraph.labels"
                :data="efficGraph.data" :categories="efficGraph.categories" class="graph5" ref="efficGraphRef" />
        </section>
    </section>
</template>

<script>
import Filters from "./commons/Filters.vue";
import RTAGraphs from "./commons/RTAGraphs.vue";
import axios from 'axios';
import { urlMainAPI, defaultSuccess, showError } from '../../global';
export default {
    name: "DashboardRTA",
    components: { RTAGraphs, Filters },
    data() {
        return {
            defaultFilters: {
                processId: null,
                workshiftId: null,
                startDate: "",
                endDate: "",
            },
            loading: false,
            showDetailedCards: true,
            graphSize: 150,
            lastUpdateCols: [
                { field: "code", key: 'code', title: 'Código', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "creationDate", key: 'creationDate', title: 'Abertura', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "indicator", key: 'indicator', title: 'Indicador', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "process", key: 'process', title: 'Processo', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "trigger", key: 'trigger', title: 'Gatilho', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "responsible", key: 'responsible', title: 'Responsável', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "workshift", key: 'workshift', title: 'Turno', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "deadline", key: 'deadline', title: 'Prazo', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
                { field: "status", key: 'status', title: 'Status', align: "center", sortBy: "", ellipsis: { lineClamp: 1 } },
            ],
            lastUpdateData: [],

            statusGraph: {
                labels: [],
                data: []
            },

            respGraph: {
                labels: [],
                data: [],
                categories: []
            },

            indGraph: {
                labels: [],
                data: [],
                categories: []
            },

            efficGraph: {
                labels: [],
                data: [],
                categories: []
            },
            exportGraphs: [{
                statusGraph: this.$refs.statusGraphRef,
                respGraph: this.$refs.respGraphRef,
                indGraph: this.$refs.indGraphRef,
                efficGraph: this.$refs.efficGraphRef
            }],
            columnWidthResizeOption: {
                enable: true,

            },
            rowStyleOption: {
                clickHighlight: false,
                hoverHighlight: false,
            },
            editOption: {
                beforeCellValueChange: () => { },
                afterCellValueChange: () => { },
            },
            cellStyleOption: {
                headerCellClass: ({ rowIndex }) => {
                    if (rowIndex == 0) {
                        return "update-header-table";
                    }
                },
            },
        }
    },
    computed: {
        statusCards() {
            return [
                { code: "Total", label: 'Total', count: 0, icon: 'statusTotal', canShow: true },
                { code: "Aberta", label: 'Abertas', count: 0, icon: 'statusOpen', canShow: true },
                { code: "AnaliseAndamento", label: 'Em Análise', count: 0, icon: 'statusReasonDoing', canShow: this.showDetailedCards },
                { code: "AnaliseAtraso", label: 'Análise em Atraso', count: 0, icon: 'statusReasonLate', canShow: this.showDetailedCards },
                { code: "AcaoAndamento", label: 'Em Ações', count: 0, icon: 'statusActionDoing', canShow: this.showDetailedCards },
                { code: "AcaoAtraso", label: 'Ações em Atraso', count: 0, icon: 'statusActionLate', canShow: this.showDetailedCards },
                { code: "Andamento", label: 'Em Andamento', count: 0, icon: 'statusDoing', canShow: !this.showDetailedCards },
                { code: "EficaciaPendente", label: 'Avaliação Pendente', count: 0, icon: 'statusAvalPending', canShow: true },
                { code: "Concluida", label: 'Concluída', count: 0, icon: 'statusDone', canShow: true },
                { code: "Cancelada", label: 'Cancelada', count: 0, icon: 'statusCancel', canShow: true },
                { code: "Recusada", label: 'Recusada', count: 0, icon: 'statusRecusa', canShow: true },
            ]
        }
    },
    methods: {
        gotToRtaList() {
            this.$router.push({ name: "rtalist" });
        },

        toggleDetailedStatus() {
            this.showDetailedCards = !this.showDetailedCards;
        },

        getStatusLabel(status) {
            const statusMap = {
                "Aberta": "Aberta",
                "AnaliseAndamento": "Em Análise",
                "AnaliseAtraso": "Análise em Atraso",
                "AcaoAndamento": "Em Ações",
                "AcaoAtraso": "Ação em Atraso",
                "EficaciaPendente": "Avaliação Pendente",
                "Concluida": "Concluída",
                "Cancelada": "Cancelada",
                "Recusada": "Recusada"
            };
            return statusMap[status] || status;
        },

        async resetFilters() {
            await this.loadDahsboardData(this.defaultFilters);
        },

        async loadDahsboardData(filters) {
            this.loading = true;

            let url = `${urlMainAPI}/getrtafordashboard`;
            let queryMount = [];

            if (filters.processId != null && filters.processId != undefined) queryMount.push(`processId=${filters.processId}`);
            if (filters.workshiftId != null && filters.workshiftId != undefined) queryMount.push(`workshiftId=${filters.workshiftId}`);
            if (filters.startDate != null && filters.startDate != undefined && filters.startDate != "" && filters.startDate != "Data inválida") queryMount.push(`startDate=${filters.startDate}`);
            if (filters.endDate != null && filters.endDate != undefined && filters.endDate != "" && filters.endDate != "Data inválida") queryMount.push(`endDate=${filters.endDate}`);

            if (queryMount.length > 0) url += `?${queryMount.join("&")}`


            await axios.get(url).then(res => {
                if (res.data) {
                    this.statusGraph.labels = res.data.StatusPieGraph.Labels.map(this.getStatusLabel);
                    this.statusGraph.data = res.data.StatusPieGraph.Values;

                    this.respGraph.labels = res.data.RespBarGraph.Labels;
                    this.respGraph.data = res.data.RespBarGraph.ValuesList;
                    this.respGraph.categories = res.data.RespBarGraph.Categories.map(this.getStatusLabel);

                    this.indGraph.labels = res.data.IndicatorLineGraph.Labels;
                    this.indGraph.data = res.data.IndicatorLineGraph.ValuesList;
                    this.indGraph.categories = res.data.IndicatorLineGraph.Categories;

                    this.efficGraph.labels = res.data.AvaliationBarGraph.Labels;
                    this.efficGraph.data = res.data.AvaliationBarGraph.ValuesList;
                    this.efficGraph.categories = res.data.AvaliationBarGraph.Categories;

                    this.statusGraph.selectedFilters = [...this.statusGraph.labels];
                    this.respGraph.selectedFilters = [...this.respGraph.labels];
                    this.indGraph.selectedFilters = [...this.indGraph.labels];
                    this.efficGraph.selectedFilters = [...this.efficGraph.labels];

                    this.lastUpdateData = [...res.data.LastUpdatedRTA];

                    this.statusCards.forEach(item => {

                        if (item.code == "Total") {
                            item.count = res.data.TotalCount;
                        }
                        else if (item.code == "Andamento") {
                            item.count = res.data.DoingCount;
                        }
                        else if (res.data.StatusCount[item.code] && res.data.StatusCount[item.code] !== undefined) {
                            item.count = res.data.StatusCount[item.code];
                        }
                    });


                    this.exportGraphs = [{
                        statusGraph: this.$refs.statusGraphRef,
                        respGraph: this.$refs.respGraphRef,
                        indGraph: this.$refs.indGraphRef,
                        efficGraph: this.$refs.efficGraphRef
                    }];
                }

                defaultSuccess("Gráficos Carregados com Sucesso!")
            }).catch(() => showError("Falha ao Carregar Gráficos."))

            this.loading = false;
        }
    },
    async mounted() {
        await this.loadDahsboardData(this.defaultFilters);
    },
}
</script>

<style>
.update-header-table {
    background: #B0B0B0 !important;
    color: #fff !important;
    font-size: 0.8rem !important;
    font-weight: 600 !important;
    padding: 0.1rem !important;
    height: 2rem !important;
    font-size: 0.8rem !important;
    vertical-align: middle !important;
}

.update-header-table span {
    display: inline-flex !important;
    align-items: center;
}

.update-header-table span i:first-child {
    top: -3px !important;
}

.update-header-table span i:last-child {
    top: 6.5px !important;
}
</style>

<style scoped>
.dashboardContainer {
    display: flex;
    flex-direction: column;
    row-gap: 0.3rem;
    height: 98%;
}

.statusHeader {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
    grid-template-rows: 5.5rem;
    column-gap: 0.5rem;
}

.statusCards {
    display: grid;
    grid-template-rows: 1fr 1rem;
    row-gap: 0.2rem;

    padding-bottom: 0.7rem;
    padding-left: 0.5rem;
    padding-right: 0.2rem;
    border: 1px solid #f0f0f0;
    border-radius: 0.3rem;
    box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.25);
    width: 100%;
    height: 100%;
}

.statusCards h2 {
    font-weight: 700;
    font-size: 2.5rem;
    align-self: flex-end;
    margin: 0;
}

.statusCards>div {
    display: flex;
    align-items: center;
    column-gap: 0.5rem;
}

.statusCards>div img {
    max-height: 0.8rem;
}

.statusCards>div span {
    font-size: 0.7rem;
    font-weight: 600;
}

.graphContainer {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
    grid-template-rows: repeat(auto-fit, minmax(12rem, auto));
    /* Linha 1 ocupa espaço necessário, Linha 2 preenche o resto */
    column-gap: 0.2rem;
    row-gap: 0.2rem;
    height: calc(100vh - 200px);
    /* Ajuste dinâmico baseado na altura da tela */
}

.graph1,
.graph2,
.graph3,
.graph4,
.graph5 {
    min-height: 250px;
    /* Evita que fiquem exageradamente altos */
}

.graph1 {
    grid-area: 1 / 1 / 2 / 2;
}

.graph2 {
    grid-area: 1 / 2 / 2 / 3;
}

.graph3 {
    grid-area: 1 / 3 / 2 / 4;
}

.graph4 {
    grid-area: 2 / 1 / 3 / 3;
}

.graph5 {
    grid-area: 2 / 3 / 3 / 4;
}

.graph4 {
    display: flex;
    flex-direction: column;
    column-gap: 0.3rem;
    padding: 0.5rem;
    box-shadow: 0 2px 5px #00000033;
    border-radius: 0.2rem;
    z-index: 0;


}

.graph4 p {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    column-gap: 0.2rem;
    word-break: keep-all;
    white-space: nowrap;
}

.graph4 p::after {
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    background-color: #e2e2e2;
}

.graph4 button {
    color: #fff;
    background-color: #008787;
    padding: 0.1rem;
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.3rem;
    font-weight: 500;
    width: 100%;
    margin-top: 0.2rem;
    font-size: 0.8rem;
}
</style>